import { v4 as uuid } from "uuid";

export const generateTraceContext = () => {
  const traceID = uuid().replace(/-/g, "");
  const spanID = uuid().replace(/-/g, "").slice(0, 16);
  return `00-${traceID}-${spanID}-01`;
};